//This is the card that displays for every worker in thee worker's page for the profile User.
//When a button is clicked on the card, we set te selected worker in the redux store and navigate to the appropiate page.
//either the transactions page or the update worker page.
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSelectedWorker } from '../features/selectedWorker/selectedWorkerSlice';
import { sendOnboardingReminder } from '../features/workers/workerSlice';
import { useState } from 'react';
import { sendCustomMsg } from '../actions/sendCustomMsg';

import { FiCheckCircle, FiCalendar, FiEdit2, FiMessageSquare } from 'react-icons/fi';

function WorkerItem({ worker }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = useSelector((state) => state.auth.user?.token);
    const [showMsgModal, setShowMsgModal] = useState(false);
    const [customMsg, setCustomMsg] = useState("");

    const handleViewTransactions = () => {
        const payload = {
            id: worker.id,
            name: worker.name,
            lastName: worker.lastName,
            profilePicture: worker.profilePicture,
            rate: worker.rate,
        };

    

        dispatch(setSelectedWorker(payload));
        navigate('/worker/attendance');
    };

    const handleSendReminder = () => {
        dispatch(sendOnboardingReminder(worker.id));
    };

    const handleOpenMsgModal = () => {
        setShowMsgModal(true);
        setCustomMsg("");
    };
    const handleCloseMsgModal = () => {
        setShowMsgModal(false);
    };
    const handleMsgChange = (e) => {
        setCustomMsg(e.target.value);
    };
    const handleSendMsg = async () => {
        const fullMsg = `Hello, ${worker.name}, ${customMsg}\n\nThis is an automated message, do not reply.`;
        try {
            await sendCustomMsg(token, worker.phone, fullMsg);
        } catch (error) {
            // Optionally show error to user
        }
        setShowMsgModal(false);
    };

  
    return (
        <article className='w-full rounded-2xl border border-border bg-surface p-4 shadow-sm transition hover:shadow-md'>
                <div className='flex items-center justify-center'>
                    <img 
                        src={worker.profilePicture ? worker.profilePicture : '/workerSilhoutte.png'} 
                        alt="workerImage" 
                    className="h-24 w-24 rounded-full border border-border object-cover"
                    />
                </div>
                
                <div className='p-1'>
                    
                   <div className='mt-3 text-center'>
                    <h1 className='my-1 px-4 text-xl font-semibold capitalize text-ink'>
                            {worker.name}
                        </h1>
                    <h1 className='my-1 px-4 text-xl font-semibold capitalize text-ink'>
                            {worker.lastName}
                        </h1>
                   </div>
                <div className='mt-4 text-center'>
                        {worker.onboarded === true ? (
                            <div className='flex items-center justify-center gap-2 rounded-md border border-active/20 bg-active/10 px-3 py-2 text-active'>
                                <FiCheckCircle className='text-lg' />
                                <span className='text-sm font-medium'>Onboarded</span>
                            </div>
                        ) : (
                        <div className='mt-2'>
                                <button
                                className='rounded-md border border-border bg-surface px-4 py-2 text-label font-medium text-ink-2 transition hover:bg-surface-2'
                                    onClick={handleSendReminder}
                                >
                                    Remind to onboard
                                </button>
                            </div>
                        )}
                    <div className='mt-3 text-sm text-ink-3'>
                            <p>{worker.role}</p>
                            <p>{`${worker.phone.slice(0, 3)}-${worker.phone.slice(3, 6)}-${worker.phone.slice(6)}`}</p>
                        </div>
                      
                       
                    </div>

                    
                </div>
                
            <div className='mt-2 flex items-center justify-between rounded-xl border border-border bg-surface-2 p-2'>
                    <button 
                    className='inline-flex h-9 w-9 items-center justify-center rounded-md text-ink-3 transition hover:bg-surface-2 hover:text-ink' 
                        onClick={handleViewTransactions}
                    aria-label="View attendance"
                    >
                    <FiCalendar className='h-4 w-4' />
                    </button>

                    <button 
                    className='inline-flex h-9 w-9 items-center justify-center rounded-md text-ink-3 transition hover:bg-surface-2 hover:text-ink'
                        onClick={handleOpenMsgModal}
                    aria-label="Send message"
                    >
                    <FiMessageSquare className='h-4 w-4' />
                    </button>

                <Link to={`/workers/update`} state={{ currentWorkerData: worker }} className='inline-flex h-9 w-9 items-center justify-center rounded-md text-ink-3 transition hover:bg-surface-2 hover:text-ink' aria-label="Edit worker">
                    <FiEdit2 className='h-4 w-4' />
                    </Link>
                </div>
                {/* Modal for custom message */}
                {showMsgModal && (
                    <div className="fixed inset-0 z-30 flex items-center justify-center bg-black bg-opacity-60">
                    <div className="w-full max-w-md rounded-xl border border-border bg-surface p-6 shadow-2xl">
                        <h2 className="mb-2 text-lg font-semibold text-ink">Send Message to {worker.name}</h2>
                            <textarea
                            className="mb-4 h-32 w-full rounded-md border border-border p-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
                                value={customMsg}
                                onChange={handleMsgChange}
                                placeholder="Type your message here..."
                            />
                        <div className="mb-3 text-body text-ink-3">
                            <span className="font-semibold text-ink">Message preview:</span>
                            <div className="mt-2 rounded-md border border-border bg-surface-2 p-2">
                                    Hello, {worker.name}, {customMsg}<br/><br/>This is an automated message, do not reply.
                                </div>
                            </div>
                            <div className="flex justify-end gap-2">
                            <button className="rounded-md border border-border bg-surface px-4 py-2 text-label font-medium text-ink-2 transition hover:bg-surface-2" onClick={handleCloseMsgModal}>Cancel</button>
                            <button className="rounded-md bg-ink px-4 py-2 text-label font-medium text-white transition hover:bg-ink-2" onClick={handleSendMsg}>Send</button>
                            </div>
                        </div>
                    </div>
                )}
        </article>
    )
}

export default WorkerItem;
